// removed by extract-text-webpack-plugin
module.exports = {"Section":"_16tqWMMQ","ContentCanvas":"_2XvqHq76","background":"-wC_Sso6","wide":"_1nYJ3yDK"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/section/section-layout.styles.scss
// module id = 211
// module chunks = 0